import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'


class IndexView extends Component {

    detailBloc = new DetailBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detailData: {},
            uuid: new URLSearchParams(window.location.search).get('uuid'),
            gagal_txt : ''
        }
    }
    
    loadDetail = async () => {
        await this.detailBloc.fetchDetail({uuid: this.state.uuid })
    }
               
    componentDidMount() {
            // const queryParams = new URLSearchParams(window.location.search)
            // console.log(this.state.uuid)
            // this.loadDetail()
            this.detailBloc.detailChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.COMPLETED:
                        if(result.data.status) {
                            let response = result.data.response
                            this.setState({
                                detailData: response
                            })
                        }
                        break
                    case apiResponse.ERROR:
                        break
                    default:
                    break
                    }
            })
            this.detailBloc.fetchDetail({uuid: this.state.uuid })
            
       
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Ubah Data Potongan Tunkin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Ubah data Tunkin 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-2">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Potongan 
                                            </label>
                                            <Col md="3">
                                               {this.state.detailData.cutting_category_name}
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Potongan 
                                            </label>
                                            <Col md="3">
                                                {(this.state.detailData.cutting_category_type!='')?((this.state.detailData.cutting_category_type==1)?'Terlambat':'Pulang Cepat'):'-'}
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-2">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jam Mulai 
                                            </label>
                                            <Col md="3">
                                                {this.state.detailData.cutting_category_start_time}
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jam Selesai 
                                            </label>
                                            <Col md="3">
                                                   {this.state.detailData.cutting_category_end_time}
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Persentase 
                                            </label>
                                            <Col md="3">
                                                   {this.state.detailData.cutting_category_percentage}
                                             &nbsp;%</Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Potongan 
                                            </label>
                                            <Col md="3">
                                            {(this.state.detailData.cutting_category_calculation_type!='')?((this.state.detailData.cutting_category_calculation_type==1)?'Tunkin':'Honorarorium'):'-'}
                                                    
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/potongan_tunkin.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    // failedTitle="Gagal!"
                    failedTitle={this.state.gagal_txt}
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/potongan_tunkin.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView